import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
  Button
} from "@mui/material";

import Logo from "../../assets/logo2.png";
import "./Header.css";
import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useLocation } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useSelector } from "react-redux";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

const settings = ["Logout"];

const Header = (props) => {
  const location = useLocation();
  const [anchorElUser, setAnchorElUser] = useState(null);
  const roles = useSelector((state) => state.user.roles);
  const existedRole = localStorage.getItem("roleDetails");
  const getRole = JSON.parse(existedRole);
  const { accounts } = useMsal();

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = async (setting) => {
    if (setting === "Logout") {
      props.handleLogout();
    }
    setAnchorElUser(null);
  };

  return (
    <div className="main-header">
      <Toolbar className="toolbar_header">
        <div className="main-box">
          <img src={Logo} alt="logo" width={85} height={25} />
          <h3 style={{ marginLeft: "120px" }}>
            Technical, Innovation & Supply Chain
          </h3>
          
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ textAlign: "right" }}>
                  <Typography sx={{ mr: 1, fontSize: "13px" }}>
                    {accounts[0]?.name}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ mr: 1, fontSize: "10px" }}
                  >
                    {roles.join(", ")}
                  </Typography>
                  {location?.pathname?.length > 3 && (
                    <Typography
                      variant="caption"
                      sx={{ mr: 1, fontSize: "11px" }}
                    >
                      {getRole?.headerLabel}
                    </Typography>
                  )}
                </Box>
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <ArrowDropDownIcon style={{ color: "#fff" }} />
                </IconButton>
              </Box>
            </Tooltip>
            <Menu
              whole
              menuItem
              in
              grey
              sx={{ mt: "30px"}} // Adjust the background color here
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
              disableScrollLock={true}
            >
              {settings.map((setting) => (
                <MenuItem
                  key={setting}
                  sx={{
                    height: "25px", // Reduce the height
                    padding: "4px 16px", // Adjust padding
                    display: "flex", // Align text and icon
                    justifyContent: "space-between",
                  }}
                  onClick={() => handleCloseUserMenu(setting)}
                >
                  <Typography sx={{ textAlign: "center" }}>
                    {setting}
                  </Typography>
                  {setting === "Logout" && <ExitToAppIcon fontSize="small" />}{" "}
                  {/* Add icon for Logout */}
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </div>
      </Toolbar>
      <div className="gradient_section"></div>
    </div>
  );
};

export default Header;
